module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av242-e84bb5be261133146eb1d5e125e10f11.jpg";